import { render } from "./EditColisPage.vue?vue&type=template&id=a8e855ae&ts=true"
import script from "./EditColisPage.vue?vue&type=script&lang=ts"
export * from "./EditColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__